import { useState } from 'react';
import useAxios from 'axios-hooks';
import DeleteConfirmationDialog from '../../../../Util/DeleteConfirmationDialog';

const DeleteCobrandDashboardTaskModal = ({
  showModal,
  toggleShowModal,
  onDelete,
  cobrandDashboardTask,
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [{ loading }, executeDelete] = useAxios(
    {
      method: "delete",
      url: `internal/dashboard-tasks/cobrand-exclusions/${cobrandDashboardTask?.cobrandDashboardTaskId}/`,
    },
    { manual: true }
  );

  const onConfirmDelete = async () => {
    try {
      const response = await executeDelete();
      if (response?.status >= 200 && response?.status < 300) {
        setErrorMessage("");
        onDelete?.();
        toggleShowModal();
        return true;
      }
    } catch (error) {
      const apiMessage =
        error?.response?.data?.message || error?.response?.data || error?.message;
      setErrorMessage(
        apiMessage ||
          "Unable to delete this dashboard task. Please ensure it is not in use and try again."
      );
    }
    return false;
  };

  const taskName = cobrandDashboardTask?.dashboardTaskSlug;

  return (
    <DeleteConfirmationDialog
      isVisible={showModal}
      onDismiss={() => {
        setErrorMessage("");
        toggleShowModal();
      }}
      onConfirm={onConfirmDelete}
      resourceName={taskName}
      resourceType="dashboard task"
      confirmationValue={taskName || "delete"}
      isDeleting={loading}
      errorMessage={errorMessage}
    />
  );
};

export default DeleteCobrandDashboardTaskModal;